import { trace } from 'rytm-helpers'
// import Pizzicato from 'pizzicato'
import WaveSurfer from 'wavesurfer.js'
import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'
import { SKIP_JUMP_SECONDS } from './../../shared/tsaw-nav-sound'

const FADE_IN_TIME = .5
const FADE_OUT_TIME = .4
const FREQ_CUT_LOW = .03;
const FREQ_CUT_HIGH = .8;

class Sound {
  /**
  * Sound class constructor  
  * @constructor
  * @param {String} file - file name with extension  
  * @param {String} path - file path  
  **/
  constructor(path, params = {}) {
    this.path = path
    this.pitch = 1
    this.volume = 1 // (0—1)
    this.volumeMax = 1 // (0—1)
    this.paused = true
    this.ended = false
    this.params = {
      container: '.waveformcanvas-' + params.trackName,
      scrollParent: false,
      skipLength: SKIP_JUMP_SECONDS,
      barWidth: 2,
      barHeight: 2,
      barRadius: 2,
      barGap: 1,
      progressColor: "#FFF",
      waveColor: "rgba(255,255,255,.3)",
      cursorColor: "rgba(255,255,255,.15)",
      hideCursor: false,
      ...params
    }
    // clear waveform wrapper
    const wfc = document.querySelector(this.params.container)
    if (wfc) {
      wfc.innerHTML = ""
    }
    this.ws = WaveSurfer.create(this.params)
    this.isReady = false
    this.playOnReady = false
    // add events
    this.ws.on('ready', this.onSoundReady.bind(this))
    this.ws.on('destroy', this.onSoundDestroy.bind(this))
    this.ws.on('play', this.onPlaybackStarted.bind(this))
    this.ws.on('pause', this.onPlaybackPaused.bind(this))
    this.ws.on('finish', this.onPlaybackEnd.bind(this))
    // load
    this.ws.load(this.path)
  }
  /**
   * #######################
   * ### Event Listeners ###
   */
  onSoundReady() {
    this.isReady = true
    if (this.playOnReady) {
      this.ws.play()
    }
  }
  onSoundDestroy() {
    this.isReady = false
    this.playOnReady = false
  }
  onPlaybackStarted() {
    this.paused = false
  }
  onPlaybackPaused() {
    this.paused = true
  }
  onPlaybackEnd() {
    if (this.onSoundEnded) {
      this.onSoundEnded(this)
    }
    if (this.params.loop == true) {
      this.play()
    }
  }
  /**
   * #####################
   * ### Sound methods ###
   */
  addOnSoundEndedEvent(method) {
    this.onSoundEnded = method
  }
  /**
   * Fade IN
   */
  fadeIn(params) {
    this.volume = 0
    this.ws.setVolume(this.volume)
    const fadeTime = params.fadeTime ? params.fadeTime : FADE_IN_TIME
    this.fadeToVolume(this.volumeMax, fadeTime)
    this.play(params)
  }
  /**
   * Fade IN
   */
  fadeOut(time = null, stop = false) {
    time = time ? time : FADE_OUT_TIME
    TweenMax.killTweensOf(this.volume)
    TweenMax.to(this, time, {
      volume: 0,
      onUpdate: () => {
        this.ws.setVolume(this.volume)
      },
      onComplete: () => {
        if (stop) {
          this.stop()
        } else {
          this.pause()
        }
        // reset volume
        this.volume = 1
        this.ws.setVolume(this.volume)
      }
    })
  }
  fadeToVolume(vol, time = null) {
    time = time ? time : FADE_IN_TIME
    TweenMax.killTweensOf(this.volume)
    // trace("FADE TO VOL", vol, this.volume)
    TweenMax.to(this, time, {
      volume: vol,
      onUpdate: () => {
        this.ws.setVolume(this.volume)
      },
      onComplete: () => {
        // reset volume
        this.volume = vol
        this.ws.setVolume(vol)
      }
    })
  }
  // set volume
  setVolume(volume) {
    this.volumeMax = volume
    if (this.ws) {
      this.fadeToVolume(volume, FADE_IN_TIME * 2)
    }
  }
  /**
   * Play sound
   */
  play(params) {
    this.playOnReady = true
    this.ws.play()
  }
  /**
   * Stop sound
   */
  stop() {
    this.playOnReady = false
    this.ws.stop()
  }
  /**
   * Pause sound
   */
  pause() {
    this.playOnReady = false
    this.ws.pause()
  }
  /**
   * Resume sound (undo pause)
   */
  resume() {
    this.playOnReady = true
    this.ws.play()
  }
  /**
   * Seek
   */
  seek(proc) {
    this.ws.seekTo(proc)
  }
  skipBackwardSec(sec) {
    const duration = this.ws.getDuration()
    if (sec > 0 && duration > 0) {
      const currentTime = this.ws.getCurrentTime()
      const destTime = currentTime - sec > 0 ? currentTime - sec : 0
      const perc = destTime / duration
      trace(currentTime, duration)
      this.seek(perc)
    }
  }
  skipBackward() {
    this.ws.skipBackward()
  }
  skipForward() {
    this.ws.skipForward()
  }
  /**
   * Destroy sound
   */
  destroy() {
    this.ws.destroy()
  }
  // get sound meta, eg. timecode
  getSoundMeta() {
    let meta = {
      time: this.ws.getCurrentTime(),
      duration: this.ws.getDuration()
    }
    return meta
  }
  // get time in secounds
  getTime() {
    return this.ws.getCurrentTime()
  }


}

export default Sound;
